// extracted by mini-css-extract-plugin
export default {"container":"OEF25dXJ","content":"zfocSjTR","amount":"EwOcwHFw","link":"KwAXOVQ_"};